export default {"src":"/_next/static/media/check-circle.8275611f.svg","height":16,"width":16};